import { TrackAddon } from '../TrackPlayer/TrackAddon';
import type { PodcastProps } from '../TrackPlayer/types';

/**
 * Podcast — Knowledge Hub add-on that plays a produced podcast episode.
 *
 * Used to be one `<Audio>` component switchable between Podcast and
 * AudioDoc via a segmented control; MED-7075 split them into their own
 * cards/tabs, each wrapping a single `<TrackPlayer>` via `<TrackAddon>`.
 *
 * Stateless data-wise: the app owns the track data (url + metadata); this
 * component owns the visual frame and playback controls.
 */
export const Podcast = (props: PodcastProps) => (
  <TrackAddon trackKey="podcast" {...props} />
);

export default Podcast;
